module.exports = __webpack_public_path__ + "img/download.ff443c2d.svg";